import { notify } from 'utils/reduxUtils';

export const types = {
  RESET: 'modules/common/forms/materialWidget/bar/RESET',
  STOCK_REQUEST_ERROR:
    'modules/common/forms/materialWidget/bar/STOCK_REQUEST_ERROR',
  STOCK_REQUEST_SUBMIT:
    'modules/common/forms/materialWidget/bar/STOCK_REQUEST_SUBMIT',
  STOCK_REQUEST_SUCCESS:
    'modules/common/forms/materialWidget/bar/STOCK_REQUEST_SUCCESS',
  RECEIVE_RESULT: 'modules/common/forms/materialWidget/bar/RECEIVE_RESULT',
};

export const barWidget = {
  reset: () => ({
    type: types.RESET,
  }),
};

export const receiveResult = ({ result }) => ({
  type: types.RECEIVE_RESULT,
  payload: { result },
});

export const stockRequest = {
  submit: ({
    barEnd,
    buffer,
    cutTolerance,
    cutWidth,
    height,
    length,
    manualBarCost,
    manualBarHeight,
    manualBarLength,
    manualBarWidth,
    materialId,
    quantity,
    submitType,
    width,
  }) => ({
    type: types.STOCK_REQUEST_SUBMIT,
    payload: {
      barEnd,
      buffer,
      cutTolerance,
      cutWidth,
      height,
      length,
      manualBarCost,
      manualBarHeight,
      manualBarLength,
      manualBarWidth,
      materialId,
      quantity,
      submitType,
      width,
    },
  }),
  success: () => ({
    type: types.STOCK_REQUEST_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.STOCK_REQUEST_ERROR,
      payload: error,
    }),
    'Stock Request Error',
  ),
};
